module.exports = __webpack_public_path__ + "img/GeoffWarner.7480c995.jpg";